
namespace GeniuzPOS.SalePromoCamp {

    @Serenity.Decorators.registerClass()
    export class PsPromoDtDialog extends Serenity.Extensions.GridEditorDialog<PsPromoDtRow> {
        protected getFormKey() { return PsPromoDtForm.formKey; }
        // protected getIdProperty() { return PsPromoDtRow.idProperty; }
        protected getLocalTextPrefix() { return PsPromoDtRow.localTextPrefix; }
        protected getNameProperty() { return PsPromoDtRow.nameProperty; }
        // protected getService() { return PsPromoDtService.baseUrl; }
        // protected getDeletePermission() { return PsPromoDtRow.deletePermission; }
        // protected getInsertPermission() { return PsPromoDtRow.insertPermission; }
        // protected getUpdatePermission() { return PsPromoDtRow.updatePermission; }

        protected form = new PsPromoDtForm(this.idPrefix);

        // public myId: number;
        // public sku: string;
        // public gpcon: string;
        public typeid:string

        constructor() {
            super();

            this.form = new PsPromoDtForm(this.idPrefix);

            this.form.PromoType.changeSelect2(e => {
                var promo = this.PromoType;
                var promon = this.PromoTypen;
                if (promo) {
                    Serenity.EditorUtils.setReadOnly(this.form.PromoPrice, true);
                    Serenity.EditorUtils.setReadOnly(this.form.PromoDiscPc, false);
                    this.form.PromoPrice.value = null;
                }
                if (promon) {
                    Serenity.EditorUtils.setReadOnly(this.form.PromoDiscPc, true);
                    Serenity.EditorUtils.setReadOnly(this.form.PromoPrice, false);

                    this.form.PromoDiscPc.value = null;
                }
            });


            this.form.ItemType.changeSelect2(e => {

                // this.form.ItemCode.value = null
                // console.log(this.form.ItemType.value)

                Serenity.EditorUtils.setReadOnly(this.form.ItemId, false);
                this.form.ItemCode.value = null;
                // this.form.ItemDesc.value = null;
                this.form.GroupCode1.value = null;
                // this.form.ItemType.value = "5"


            });
            this.form.ItemId.changeSelect2(e => {
                
                
                var codeid = Q.toId(this.form.ItemId.value)
                var id :string = this.form.ItemId.value
                // แก้ไขบัคไอดีซ้ำของแต่ละประเภท 1/10/2567
                let Qtype = Q.toId(this.form.ItemType.value)
                console.log(codeid)
                console.log(Qtype)
                this.form.ItemCode.value = LookupItemCodeRow.getLookup().itemById[id].ItemCode
                
                
                if (Qtype == 1) {
                    // var code = Q.toId(this.form.ItemCode.value)
                    var co :string = this.form.ItemCode.value
                    // console.log(code) 
                    // console.log(c) 
                    // this.form.GroupCode1.value = (Product.CsPluRow.getLookup().itemById[codeid].SellUnitPrice1).toString();
                    let coo = Q.tryFirst(Product.CsPluRow.getLookup().items, x => x.PluCode == co)
                    this.form.GroupCode1.value = coo.SellUnitPrice1.toString();
                    this.form.DescItem.value = ((LookupItemCodeRow.getLookup().itemById[id].ItemDesc)).toString();
                    let s =Q.tryFirst(Product.CsSkuRow.getLookup().items, x => x.SkuCode == coo.SkuCode)
                    this.form.GpNormal.value =  s.ConsignGp ?? 0;

                } else {
                    
                    
                    this.form.DescItem.value = ((LookupItemCodeRow.getLookup().itemById[id].ItemDesc)).toString();
                }
            });


        }

        private get PromoType() {
            return this.form.PromoType.value != "1";
        }
        private get PromoTypen() {
            return this.form.PromoType.value != "2";
        }
        // private get ItemCodesn() {
        //     return this.form.PromoType.value === '1';
        // }
        // private get ItemCodes() {
        //     return this.form.PromoType.value !== "1";
        // }




        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.isNew) {

                Serenity.EditorUtils.setReadOnly(this.form.ItemId, true);
                Serenity.EditorUtils.setReadOnly(this.form.PromoDiscPc, true);
                Serenity.EditorUtils.setReadOnly(this.form.PromoPrice, true);

                
                this.toolbar.findButton('button-apply').hide();
            }
        }
        // private saveAndNew() {
        //     let e = this.entity; let f = this.form;

        //     this.save((response) => {
        //         let ent: PsPromoDtRow = { PromoId: e.PromoId };
        //         this.loadEntity(ent);
        //     });

        // }

    }
}